// dateFormats.js
export const DATE_DISPLAY_FORMAT = 'DD/MM/YYYY'
export const DATE_DISPLAY_FORMAT_HOURS = 'hh:mm - DD/MM/YYYY'
